const PRODUCTION_TRACKING_HOSTS = new Set([
  "cookandchef.in",
  "www.cookandchef.in",
]);

export function isProductionTrackingHost(
  hostname = typeof window !== "undefined" ? window.location.hostname : ""
) {
  return PRODUCTION_TRACKING_HOSTS.has(String(hostname || "").toLowerCase());
}

export function isTrackingEnabled() {
  if (process.env.REACT_APP_IS_STAGING === "true") {
    return false;
  }

  if (typeof window === "undefined") {
    return false;
  }

  return isProductionTrackingHost(window.location.hostname);
}
